import React from 'react'
import { Button } from '@material-ui/core';
import { PostAdd } from '@material-ui/icons';
import PropTypes from 'prop-types';

const FormSaveDraftButton = (props) => {
    const { title, color, onClick, label } = props;

    return (
        <Button
            type="button"
            variant="contained" 
            color={color || "secondary"}
            title={title || 'Guardar borrador'}
            onClick={onClick}
            startIcon={<PostAdd />}
    >{label||'Guardar borador'}</Button>);
}

FormSaveDraftButton.propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string
}

export default FormSaveDraftButton;